import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaBars, FaTimes, FaArrowRight } from "react-icons/fa";
import logo from "../assets/logo.png";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Capabilities", path: "/services" },
    { name: "Projects", path: "/projects" },
    { name: "Contact", path: "/contact" },
  ];

  // Helper function to force page scroll reset to the top
  const handlePageTransition = () => {
    setMenuOpen(false);
    window.scrollTo({
      top: 0,
      behavior: "instant", // Jumps instantly to the top right as the new page loads
    });
  };

  return (
    <nav className="fixed top-0 left-0 w-full z-50 bg-white border-b border-slate-200 shadow-sm">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-24">

          {/* Logo */}
          <Link
            to="/"
            onClick={handlePageTransition}
            className="flex items-center gap-4 transition duration-300"
          >
            <div className="bg-white rounded-lg">
              <img
                src={logo}
                alt="VAMCO & ASSOCIATES Logo"
                className="h-14 lg:h-16 w-auto object-contain"
              />
            </div>

            <div>
              <h1 className="text-2xl lg:text-3xl font-black tracking-wide text-[#0A1A3F]">
                VAMCO
              </h1>

              <p className="text-[11px] uppercase tracking-[3px] font-semibold text-slate-500">
                Engineering 
              </p>
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-12">

            <div className="flex items-center gap-8">
              {navLinks.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  onClick={handlePageTransition}
                  className={({ isActive }) =>
                    `relative uppercase tracking-[1.5px] text-sm font-semibold transition-all duration-300 ${
                      isActive
                        ? "text-[#0A1A3F]"
                        : "text-slate-500 hover:text-[#0A1A3F]"
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {item.name}

                      {isActive && (
                        <span className="absolute -bottom-3 left-0 w-full h-[2px] bg-[#C8A96B] rounded-full" />
                      )}
                    </>
                  )}
                </NavLink>
              ))}
            </div>

            {/* CTA Link Button */}
            <Link 
              to="/contact"
              onClick={handlePageTransition}
              className="group bg-[#0A1A3F] hover:bg-[#13295C] text-white px-7 py-3.5 rounded-md font-semibold uppercase tracking-wider text-sm transition-all duration-300 shadow-lg flex items-center gap-3 decoration-none"
            >
              Get Quote
              <FaArrowRight className="text-xs transition-transform duration-300 group-hover:translate-x-1" />
            </Link>

          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-2xl text-[#0A1A3F]"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>

        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden bg-white border-t border-slate-200 transition-all duration-300 overflow-hidden ${
          menuOpen ? "max-h-[500px]" : "max-h-0"
        }`}
      >
        <div className="px-6 py-5 space-y-2">

          {navLinks.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={handlePageTransition}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-lg uppercase text-sm font-semibold tracking-wider transition duration-300 ${
                  isActive
                    ? "bg-slate-100 text-[#0A1A3F]"
                    : "text-slate-600 hover:bg-slate-50"
                }`
              }
            >
              {item.name}
            </NavLink>
          ))}

          {/* Mobile CTA Link Button */}
          <Link 
            to="/contact"
            onClick={handlePageTransition}
            className="block text-center w-full mt-4 bg-[#0A1A3F] text-white py-4 rounded-md uppercase tracking-wider font-semibold hover:bg-[#13295C] transition duration-300 decoration-none"
          >
            Get Quote
          </Link>

        </div>
      </div>
    </nav>
  );
}

export default Navbar;